import { useCallback } from 'react';
import { isSameDay, isSameMonth } from 'date-fns';

interface UseDateSelectionHook {
    handleSelectDate: (date: Date) => void;
    handleDateHover: (date: Date, isMouseDown: boolean) => void;
};

const useDateSelection = (
    currentDate: Date,
    selectedDates: Date[],
    setSelectedDates: (dates: Date[]) => void
): UseDateSelectionHook => {
    const updateSelectedDates = useCallback(
        (date: Date) => {
            if (!isSameMonth(date, currentDate)) return;

            const newSelectedDates = [...selectedDates];
            const index = newSelectedDates.findIndex(selectedDate => isSameDay(selectedDate, date));
            if (index >= 0) {
                newSelectedDates.splice(index, 1);
            } else {
                newSelectedDates.push(date);
            }
            setSelectedDates(newSelectedDates);
        },
        [currentDate, selectedDates, setSelectedDates]
    );

    const handleSelectDate = useCallback(
        (date: Date) => {
            updateSelectedDates(date);
        },
        [updateSelectedDates]
    );

    const handleDateHover = useCallback(
        (date: Date, isMouseDown: boolean) => {
            if (isMouseDown) {
                updateSelectedDates(date);
            }
        },
        [updateSelectedDates]
    );

    return { handleSelectDate, handleDateHover };
};

export default useDateSelection;
